import { isEmptyArray, isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { GpPodiumListQuery } from '../types';


/**
 * typeguard for GpPodiumListQuery
 * @param GpPodiumListQuery object passed to transformer
 */
export const isValidGpPodiumList = (obj: GpPodiumListQuery): boolean => { 
    return Boolean(!isEmptyArray(obj?.data?.getGpPodiumListWidget?.grandPrixList) && obj?.data?.getGpPodiumListWidget && !isEmptyObject(obj.data.getGpPodiumListWidget ));
};
